import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

export const isAuthGuard: CanActivateFn = () => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const redirectUrlTree = router.createUrlTree(['/login/sso']);

  return authenticationService.checkAuth().pipe(
    map(({ isAuthenticated }) => isAuthenticated || redirectUrlTree),
    catchError(() => of(redirectUrlTree))
  );
};
